import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch';
import TextField from "@material-ui/core/TextField";
import BeatLoader from 'react-spinners/BeatLoader';
import FormControl from '@material-ui/core/FormControl';
import LoadingOverlay from 'react-loading-overlay';
import { Box } from '@material-ui/core';
import Button from 'react-bootstrap-button-loader';
import { formatDate, isNullOrEmpty, isIOS } from '@utils';
import * as storage from '@utils/storage'
import i18next from 'i18next';
import styles from '@styles/approvalCentral.module.css';
import { getCentralApprovalTypeDescription, approvalType } from '@scripts/CentralApprovalTypeHelper';
import { getCentralApprovalStatusDescription, centralApprovalStatus } from '@scripts/CentralApprovalStatusHelper';

const useStyles = makeStyles({
    table: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '50%'
            }
        },
    }
});

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledCommentTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

export default function RequestDetailShiftDisplay(props) {

    const classes = useStyles();

    const {
        data,
        dataRequest,
        saveClick,
        comment,
        setComment,
        isToReplace,
        setIsToReplace,
        isPosting,
        handleRequest,
        getIsLeaveRequest,
        getIsActionButtonShown,
        getIsDenyButtonEnabled,
        getIsApproveButtonEnabled
    } = props;
    const [isiOS] = useState(isIOS());
    const [isActive, setIsActive] = useState(false);
    const [approverComment, setApproverComment] = useState(comment);
    const [isActionButtonShown] = useState(getIsActionButtonShown(data));
    const [isDenyButtonEnabled] = useState(getIsDenyButtonEnabled(data));
    const [isApproveButtonEnabled] = useState(getIsApproveButtonEnabled(data));
    const [denyTitle] = useState(!getIsLeaveRequest(data) && data.statusCode == centralApprovalStatus.CLOSE ? i18next.t('approvalCentral:button.cancel') : i18next.t('approvalCentral:button.deny'));
    const [isEditable] = useState(!dataRequest.isAzur
        && !(!storage.getIsSuperUser()
            && (data.statusCode == centralApprovalStatus.CANCELED || data.statusCode == centralApprovalStatus.CLOSE)
            && !dataRequest.isCurrentSupervisorLastEdit));

    const actionType = {
        DENY: 'R',
        APPROVE: 'F'
    }

    useEffect(() => {
        resizeForm();
    }, [])

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = isiOS ? 73 : 63;
            const customHeight = height - titleBar - offSet;
            const element = document.querySelector('#divDetailLeave');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }

            setIsActive(false);
        }, 100);
    }

    const onToReplace = (event) => {
        setIsToReplace(event.target.checked);
    }

    const onChangeComment = (event) => {
        setApproverComment(event.target.value);
    }

    const handleRequestClick = (event, action) => {
        setComment(approverComment);
        handleRequest(event, data, action, false);
    }

    const handleSaveClick = () => {
        setComment(approverComment);
        saveClick(approverComment);
    }

    return (
        <React.Fragment>
            <div id="divDetailLeave" className={styles.detailRequest}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>Type</StyledFirstTableCell>
                                <StyledSecondTableCell>{getCentralApprovalTypeDescription(data.approvalType)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeCode")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{data.employeeCode}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeName")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{data.employeeFullName}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.hiringDate")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.hireDate, 'date')}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.seniorityDate")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.seniorityDate, 'date')}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.status")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{getCentralApprovalStatusDescription(data.statusCode)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeApplicant")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.employeeApplicant}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.employeeTarget")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.employeeTarget}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.targetDate")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(dataRequest.targetDate, 'date')}</StyledSecondTableCell>
                            </TableRow>
                            {!isNullOrEmpty(dataRequest.schedule) && <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.slot")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{dataRequest.schedule}</StyledSecondTableCell>
                            </TableRow>}
                            {!isNullOrEmpty(dataRequest.scheduleExchange) && <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.targetedShift")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{dataRequest.scheduleExchange}</StyledSecondTableCell>
                            </TableRow>}
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.approved")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{i18next.t(`approvalCentral:table.${data.isApproved ? "yes" : "no"}`)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.approver")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.approverName}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.approval-date")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.approvalDate)}</StyledSecondTableCell>
                            </TableRow>
                            {!isNullOrEmpty(dataRequest.otherClassification) && <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.otherClassification")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.otherClassification}</StyledSecondTableCell>
                            </TableRow>}
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.comment")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.employeeComment}</StyledSecondTableCell>
                            </TableRow>
                            {!isEditable && <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.approver-comment")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.approverComment}</StyledSecondTableCell>
                            </TableRow>}
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.creation-date")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.creationDate)}</StyledSecondTableCell>
                            </TableRow>

                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("approvalCentral:form.statusToReplace")}</StyledFirstTableCell>
                                <StyledSecondTableCell>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                disabled={true}
                                                checked={isToReplace}
                                                onChange={onToReplace}
                                                name="isToReplace"
                                                variant="success"
                                            />
                                        }
                                        labelPlacement="start"
                                    />
                                </StyledSecondTableCell>
                            </TableRow>

                            {isEditable && <TableRow>
                                <StyledCommentTableCell>{i18next.t("approvalCentral:form.approver-comment")}</StyledCommentTableCell>
                                <StyledSecondTableCell>
                                    <TextField
                                        id="comments"
                                        //label={i18next.t('approvalCentral:form.approver-comment')}
                                        multiline
                                        minRows={4}
                                        className={styles.inputComments}
                                        value={approverComment || ''}
                                        onChange={onChangeComment}
                                    />
                                </StyledSecondTableCell>
                            </TableRow>}

                        </TableBody>
                    </Table>
                </TableContainer>

                <Box display="flex" justifyContent="space-evenly" marginTop={2} marginBottom={3}>
                    {isActionButtonShown && !dataRequest.isAzur &&
                        !storage.getAllowConsultation() && <LoadingOverlay
                            active={isActive}
                            spinner={<BeatLoader />}
                            text={i18next.t('approvalCentral:form.loading')}
                        >
                            <FormControl fullWidth>
                                <Button
                                    onClick={(event) => handleRequestClick(event, actionType.APPROVE)}
                                    className={`approveButton ${styles.buttonStyle} ${(isPosting || !isApproveButtonEnabled) ? styles.buttonDisabled : ""}`}
                                    variant="success"
                                >
                                    {i18next.t('approvalCentral:button.approve')}
                                </Button>
                            </FormControl>
                        </LoadingOverlay>
                    }

                    {isActionButtonShown && !dataRequest.isAzur &&
                        !storage.getAllowConsultation() && <LoadingOverlay
                            active={isActive}
                            spinner={<BeatLoader />}
                            text={i18next.t('approvalCentral:form.loading')}
                        >
                            <FormControl fullWidth>
                                <Button
                                    onClick={(event) => handleRequestClick(event, actionType.DENY)}
                                    className={`denyButton ${styles.buttonStyle} ${(isPosting || !isDenyButtonEnabled) ? styles.buttonDisabled : ""}`}
                                    variant="success"
                                >
                                    {denyTitle}
                                </Button>
                            </FormControl>
                        </LoadingOverlay>
                    }

                    {isEditable && !dataRequest.isAzur && <LoadingOverlay
                        active={isActive}
                        spinner={<BeatLoader />}
                        text={i18next.t('approvalCentral:form.loading')}
                    >
                        <FormControl fullWidth>
                            <Button
                                onClick={handleSaveClick}
                                className={`saveButton` + ` ` + styles.buttonStyle}
                                variant="success"
                            >
                                {i18next.t('approvalCentral:button.save')}
                            </Button>
                        </FormControl>
                    </LoadingOverlay>}
                </Box>

            </div>
        </React.Fragment>
    );
}

RequestDetailShiftDisplay.propTypes = {
    data: PropTypes.object.isRequired,
    dataRequest: PropTypes.object.isRequired
}